module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', [_vm._v("Over the years I have met many interesting people. These people have guided my thinking and learning processes. First of all, my good friend and walking library Dr. Jo Vandermeulen, clinical neuropsychologist. I have never met anyone who has so much knowledge ready. Further my best friend Dr. Arthur Boon, neurologist. Someone with whom I can discuss absolutely anything and who provides strong direction in terms of advice and ideas about how the brain works. Our walks across the moor with the three dogs turned out to be decisive in the structure of chapters and what should and should not be discussed. In addition, working at Chelsea FC with footballer John Terry, he showed me what a true champion is and what it takes to become the absolute best in the world. Last but not least my soul mates Andre Gallo and Alessandro Marino, who have reached the world top in classical music from scratch.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ee3483c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0